module.exports = __webpack_public_path__ + "static/media/person_pin_24px_outlined.85f82e70.svg";